import {
  AssetProvider, AssetType, IAssetDownload, IAsset,
} from '@imcc/transport';

export class ImageSearchHit implements IAsset {
  agency: string;

  area: string;

  assetType: AssetType.Image;

  category: string;

  copyright: string;

  downloadUrl: string;

  downloads: IAssetDownload[];

  dpi: number;

  editionYear: number;

  fileExtension: string;

  hasAnimals: boolean;

  hasClippingPath: boolean;

  hasPeople: boolean;

  height: number;

  id: string;

  isReleased: boolean;

  name: string;

  orientation: string;

  producedFor: string;

  productDescription: string;

  productName: string;

  productType: string;

  productionMethod: string;

  provider: AssetProvider.Internal;

  releaseDateAt: Date;

  relevanceScore: number;

  section: string;

  thumbnailUrl: string;

  smallThumbnailUrl: string;

  previewUrl: string;

  uploadedAt: Date;

  width: number;
}
